import { OnboardingModal } from '#components'

interface OnboardingStep {
  image: string
  title: string
  text: string
}

interface OnboardingOptions {
  steps: OnboardingStep[]
  title?: string
  modalKey?: string
  auto?: boolean
}

export function useOnboarding() {
  const overlay = useOverlayWithAd()

  function showOnboarding(options: OnboardingOptions) {
    const modal = overlay.create(OnboardingModal, {
      props: {
        steps: options.steps,
        title: options.title || 'Découvrir les nouveautés',
        modalKey: options.modalKey || 'onboarding_modal',
        auto: options.auto ?? false,
      },
    })

    return modal.open()
  }

  return {
    showOnboarding,
  }
}
